<div class="keyVaultModelContainer">
    <div class="">
      <button (click)="onCancelClick(true)" type="button" class="close cancelBtn" aria-label="Close" mat-dialog-close>
        Close
      </button>
    </div>
    <div class="modelTitle heading2 alignCenter">
      <span>Create Azure Keyvault</span>
    </div>
    <div class="modelBody regularText">
      <form [formGroup]="keyvaultDetailsForm">
        <div *ngIf="isLoading" class="svg-loader"></div>
        <div class="form-group row">
          <div class="col-1"></div>
          <label for="keyvaultName" class="col-4 mandatory-field no-padding"><strong>Keyvault Name</strong></label>
          <div class="col-6 zero-padding">
            <input type="text" formControlName="keyvaultName" class="form-control" id="keyvaultName" maxlength="24" required />
          </div>
          <div class="col-1"></div>
        </div>
        <div class="form-group row mt-3">
          <div class="col-1"></div>
          <label for="accessRights" class="col-4 mandatory-field no-padding"><strong>Grant Access To:</strong></label>
          <div class="col-6 zero-padding">
          <mat-select id="keyVault" class="drpdwnaccess form-control" formControlName="accessRights" multiple>
            <mat-option *ngFor="let resource of resourceList" [value]="resource.objectId">{{resource.resourceName}}</mat-option>
          </mat-select>
        </div>
          <div class="col-1"></div>
        </div>
        <div class="d-flex alignCenter">
          <button type="submit" class="saveBtn2 mt-2" [disabled]="!keyvaultDetailsForm.valid"
            (click)="createKeyvault()">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
